import { useMemo } from 'react';
import { object, string } from 'yup';

export function usePlanningDataSchema() {
    return useMemo(
        () =>
            object().shape({
                organisationId: string().required(),
            }),
        [],
    );
}
